<div class="container">
    <div>
        Welcome!
    </div>
    <div class="form-group">
        Join game! Enter game code below, then tap 'Join Game':
        <div class="input-group">
            <input type="text" [formControl]="gameCode" class="form-control">
        </div>
        <div class="input-group">
            <button (click)="onJoinGameClick()" class="btn btn-outline-dark">Join Game</button>
        </div>
    </div>
    <div class="form-group">
        New game! Tap 'New Game' below:
        <div class="input-group">
            <button (click)="onNewGameClick()" class="btn btn-outline-dark">New Game</button>
        </div>
    </div>
</div>

<ng-template #joinGameModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Enter username</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label>Username</label>
            <div class="input-group">
                <input type="text" class="form-control" [formControl]="username">
            </div>
        </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="onUsernameSubmitClick()">Continue</button>
    </div>
</ng-template>